import {Alert, Button, Grid, IconButton, Box} from '@mui/material'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import React, {useEffect, useState} from 'react'
import ImageLogic from '../logic/ImageLogic'
import imageCompression from 'browser-image-compression'
import {humanFileSize} from '../logic/Utils'
import CloseIcon from '@mui/icons-material/Close'
import {pink} from '@mui/material/colors'

interface ImageSelectorProps {
  label: string
  refreshNumber?: number
  change: (imageFile: any) => void
  initialImagePreviewUrl?: string
}

export default function ImageSelector(props: ImageSelectorProps) {
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string>('')
  const [imageError, setImageError] = useState<string>('')

  const defaultRefreshNumber = 0

  useEffect(() => {
    setImagePreviewUrl(props.initialImagePreviewUrl || '')
    setImageError('')
  }, [props.refreshNumber !== undefined ? props.refreshNumber : defaultRefreshNumber, props.initialImagePreviewUrl])

  const removeImage = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault()
    clearImage()
    props.change(null)
  }

  const clearImage = () => {
    setImageError('')
    setImagePreviewUrl('')
  }

  const fileChange = async (e: any) => {
    let file = e.target.files[0]

    if (!file) {
      return
    }

    clearImage()

    if (!ImageLogic.isAllowedFileType(file)) {
      setImageError('Invalid file type')
      return
    }

    // console.log(`file name: ${file.name}`)
    // console.log(`originalFile size ${humanFileSize(file.size)}`)

    const options = {
      maxWidthOrHeight: 800,
      useWebWorker: true
    }

    const compressedFile = await imageCompression(file, options)

    // console.log(`compressedFile size ${humanFileSize(compressedFile.size)}`)

    setImagePreviewUrl(URL.createObjectURL(compressedFile))

    // Notify parent of change
    props.change(compressedFile)
  }

  return (
    <>
      <Grid container  >
      <Grid item xs={12} md={5} sx={{p: 1}}>
  
        
        <label>
          <input accept="image/jpeg,image/png" type="file" style={{display: 'none'}} onChange={fileChange}/>
          <Button
            startIcon={<AddPhotoAlternateIcon />}
            variant="outlined"
            aria-label="upload picture" 
            component="span"
            sx={{fontSize: '16px',
              textTransform: 'none',
              display: "flex",
              alignItems: "center",
            }}
          >
           Add Image
          </Button>
          
        </label>
        <Button startIcon={<CloseIcon sx={{color: pink[600]}}/>}
                variant="outlined" sx={{mt: 2, fontSize: '16px',
                  textTransform: 'none',
                  display: "flex",
                  alignItems: "center",
                  width: '1'
                }}
                onClick={removeImage}>Remove Image</Button>
        {imageError && <Alert severity="error">{imageError}</Alert>}
      </Grid>
        <Grid item md={7} sx={{p: 1, maxWidth: 1}}>
      <Box sx={{ml: {xs: 0, md: 4}, mt: {xs: 1, md: 0}}}>
        {imagePreviewUrl && <img src={imagePreviewUrl} alt='preview image' style={{maxHeight: '220px', maxWidth:'100%'}}/>}
      </Box>
          
        </Grid>
        
        </Grid>
    </>
  )
}
